<template>
  <div v-if="order && order.status == 'pending'">
    <CTA
      :content="`Annulla l'ordine`"
      :color="`danger`"
      @click="dialog = true"
    />
    
    <v-dialog v-model="dialog" width="600" :fullscreen="!$mq.isDesktop()" v-if="order.recurring">
      <v-card class="pa-5 text-center">
        <div class="flex justify-content-end"> 
          <v-btn @click="setDialog(false)" icon><i class="fas fa-close" style='font-size: 32px'/></v-btn>
        </div>
        <h3 class="text-center">Stai per annullare il tuo ordine!</h3>
        <p>Attenzione! Il tuo abbonamento resterà comunque attivo e potrai gestirlo dalla sezione "Abbonamento" del tuo profilo.</p>
        <div class="flex">
          <div class="flex-fill"></div>
          <CTA
            :content="`Annulla l'ordine`"
            :color="`danger`"
            :disabled="loading"
            :loading="loading"
            @click="!loading && cancelOrder()"
          />
          <div class="flex-fill"></div>
        </div>
        <a type="button" @click="setDialog(false)" style="color: var(--quomi-blue)">chiudi avviso</a>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" width="600" :fullscreen="!$mq.isDesktop()" v-else>
      <v-card class="pa-5 text-center">
        <h3 class="text-center">Sei sicuro di voler annullare l'ordine?</h3>
        <p>L'operazione è irreversibile, ma potrai sempre creare un nuovo ordine</p>
        <div class="flex">
          <div class="flex-fill"></div>
          <CTA
            :content="`Annulla l'ordine`"
            :color="`danger`"
            :disabled="loading"
            :loading="loading"
            @click="!loading && cancelOrder()"
          />
          <div class="flex-fill"></div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script type="text/javascript">

import { orderStore } from '../../store/orderStore'

export default {
	data () {
		return {
      loading: false,
      dialog: false
		}
	},
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  computed: {
    user() {
      return this.$root.user
    }
  },
  methods: {
    cancelOrder() {
      this.loading = true;
      orderStore.saveOrderToStoreFromEntity(this.order);
      orderStore.deleteCurrentOrder().finally(i => {
        this.user.order = null;
        orderStore.state.order = null;
        this.$root.updateUser(this.user)
        this.loading = false;
        this.$emit("deleted")
      })
    },

    setDialog(param) {
      this.dialog = param
    }
  }
}
</script>
